function init(): void{
  window._wq = window._wq || [];

  const customThumbMap = {};
  document.querySelectorAll<HTMLElement>(".wistia_embed").forEach(embed => {
    const hash = embed.dataset.videoHash;
    const thumb = embed.dataset.customThumb;
    if (hash && thumb) {
      customThumbMap[hash] = thumb;

      embed.style.backgroundImage = `url('${thumb}')`;
      embed.style.backgroundSize = "cover";
      embed.style.backgroundPosition = "center";

      _wq.push({ id: hash, options: { poster: thumb } });
    }
  });

  const io = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const embed = entry.target as HTMLElement;
        const hash = embed.dataset.videoHash;
        if (!hash) {
          obs.unobserve(embed);
          return;
        }

        embed.classList.add(`wistia_async_${hash}`);
        obs.unobserve(embed);
      }
    });
  }, { threshold: 0.25 });

  document.querySelectorAll<HTMLElement>(".wistia_embed").forEach(embed => {
    if (!embed.dataset.videoHash) return;

    io.observe(embed);
  });
}

export default { init };
